import React from "react";
import {
    Modal,
    ModalClose,
    ModalContent,
    ModalFooter,
    ModalHeader,
} from "#app/interface/modal/Modal";
import { Body, Title2, Title3 } from "#app/components/texts/Typography";

export interface LicenceModalProps {
    id?: string;
    show?: boolean;
    onClose?: () => void;
}

const LicenceModal: React.FC<LicenceModalProps> = ({ id, show, onClose }) => {
    const handleClose = () => {
        onClose?.();
        Modal.handleClose();
    };

    return (
        <Modal id={id} show={show} trigger="">
            <ModalHeader>
                <Title2 white left>
                    Лицензионное соглашение (EULA)
                </Title2>
                <ModalClose id="close-icon" onClick={handleClose}>
                    <div />
                </ModalClose>
            </ModalHeader>
            <ModalContent>
                <Title2 white>
                    ЛИЦЕНЗИОННОЕ СОГЛАШЕНИЕ С КОНЕЧНЫМ ПОЛЬЗОВАТЕЛЕМ МОБИЛЬНОГО ПРИЛОЖЕНИЯ
                    (EULA)
                </Title2>
                <br />
                <br />
                <Body white left>
                    ПОЖАЛУЙСТА, ВНИМАТЕЛЬНО ПРОЧИТАЙТЕ ЭТО ЛИЦЕНЗИОННОЕ СОГЛАШЕНИЕ С КОНЕЧНЫМ
                    ПОЛЬЗОВАТЕЛЕМ МОБИЛЬНОГО ПРИЛОЖЕНИЯ («СОГЛАШЕНИЕ С EULA»), ПЕРЕД ЗАВЕРШЕНИЕМ
                    ПРОЦЕССА ЗАГРУЗКИ ИЛИ УСТАНОВКИ ИЛИ ИСПОЛЬЗОВАНИЯ ПРИЛОЖЕНИЯ, ПОСКОЛЬКУ ОНО
                    СОДЕРЖИТ ВАЖНУЮ ИНФОРМАЦИЮ, КАСАЮЩУЮСЯ ВАШИХ ЮРИДИЧЕСКИХ ПРАВ И СРЕДСТВ
                    ЗАЩИТЫ.
                </Body>
                <br />
                <br />
                <Body white left>
                    Последняя редакция: 08.04.2024, 09:16:44.
                </Body>
                <br />
                <Title3 white left>
                    1. ОБЗОР
                </Title3>
                <br />
                <Body left white>
                    Настоящее Лицензионное соглашение является юридически обязывающим
                    соглашением, заключенным между ООО "ДАТА ТЭКНОЛОДЖИСЕНД АНАЛИТИКС
                    КОНСАЛТИНГ", юридический адрес 150000, Россия, г. Ярославль, ул.
                    Первомайская, 7А, стр. 1, ("Blackswanfinance") и вами, и вступает в силу с
                    момента загрузки, установки или использования вами Приложения
                    Blackswanfinance ("Приложение") или с даты вашего электронного согласия.
                </Body>
                <Body left white>
                    Настоящее соглашение EULA устанавливает общие положения и условия
                    использования вами Приложения, предоставляет лицензию на использование
                    Приложения Blackswanfinance и содержит отказ от ответственности. Условия
                    настоящего соглашения EULA также применяются к любому обновлению Приложения,
                    обновлению, интернет-услугам и услугам поддержки Приложения. Независимо от
                    того, приобретаете ли вы Приложение непосредственно у Blackswanfinance или
                    через авторизованного реселлера Blackswanfinance, ваше электронное принятие
                    настоящего соглашения EULA означает, что вы прочитали, поняли, подтвердили и
                    соглашаетесь соблюдать настоящее соглашение EULA.
                </Body>
                <Body left white>
                    Термины «мы», «нас» или «наш» относятся к Blackswanfinance. Термины «вы»,
                    «ваш» или «Пользователь» относятся к любому физическому или юридическому
                    лицу, которое принимает настоящее соглашение EULA, использует наше
                    Приложение или имеет доступ к нашему Приложению.
                </Body>
                <Body left white>
                    Blackswanfinance может по своему единоличному усмотрению изменять или
                    модифицировать настоящее Соглашение, а также любые политики или соглашения,
                    включенные в него, в любое время, и такие изменения или модификации вступают
                    в силу немедленно после публикации. Использование вами данного Приложения
                    после внесения таких изменений или модификаций будет означать ваше согласие
                    с настоящим соглашением EULA в последней редакции.
                </Body>
                <Body left white>
                    СКАЧИВАЯ/УСТАНАВЛИВАЯ/ИСПОЛЬЗУЯ ПРИЛОЖЕНИЕ, ВЫ ПОДТВЕРЖДАЕТЕ, ЧТО ПРОЧИТАЛИ
                    И ПОНИМАТЕ НАСТОЯЩЕЕ СОГЛАШЕНИЕ. ЕСЛИ ВЫ НЕ СОГЛАСНЫ СОБЛЮДАТЬ НАСТОЯЩЕЕ
                    СОГЛАШЕНИЕ С EULA В ПОСЛЕДНЕЙ ПЕРЕСМОТРЕННОЙ ВЕРСИИ, НЕ СКАЧИВАЙТЕ, НЕ
                    УСТАНАВЛИВАЙТЕ, ИСПОЛЬЗУЙТЕ (ИЛИ ПРОДОЛЖАЙТЕ ИСПОЛЬЗОВАТЬ) НАШЕ ПРИЛОЖЕНИЕ.
                </Body>
                <br />
                <Title3 white left>
                    2. ПРАВОМОЧНОСТЬ
                </Title3>
                <br />
                <Body left white>
                    Наше Приложение доступно только Пользователям, которые могут заключать
                    юридически обязательные договоры в соответствии с применимым
                    законодательством. Загружая или используя это Приложение, вы заявляете и
                    гарантируете, что вам (i) исполнилось восемнадцать (18) лет, (ii) иным
                    образом признаны способными заключать юридически обязательные контракты в
                    соответствии с применимым законодательством, и (iii) не являетесь лицом,
                    которому запрещено покупать или использовать Приложение в соответствии с
                    законодательством России или другой применимой юрисдикции.
                </Body>
                <Body left white>
                    Если вы заключаете настоящее соглашение EULA от имени компании или любого
                    юридического лица, вы заявляете и гарантируете, что у вас есть юридические
                    полномочия связывать такое юридическое лицо положениями и условиями,
                    содержащимися в настоящем соглашении EULA, и в этом случае условия « «вы»,
                    «ваш» или «Пользователь» относятся к такому юридическому лицу. Если у вас
                    нет таких полномочий или вы не согласны с условиями настоящего соглашения
                    EULA, не устанавливайте и не используйте Приложение, а также вы не должны
                    принимать настоящее соглашение EULA. Если после вашего электронного принятия
                    настоящего Соглашения Blackswanfinance обнаружит, что у вас нет юридических
                    полномочий связывать обязательства с таким юридическим лицом, вы будете
                    нести личную ответственность за обязательства, содержащиеся в настоящем
                    соглашении EULA.
                </Body>
                <br />
                <Title3 white left>
                    3. ПРЕДОСТАВЛЕНИЕ ЛИЦЕНЗИИ
                </Title3>
                <br />
                <Body left white>
                    В соответствии с условиями настоящего Соглашения Blackswanfinance настоящим
                    предоставляет вам личную, отзывную, действующую по всему миру,
                    неисключительную, не подлежащую сублицензированию и не подлежащую передаче
                    лицензию на использование Приложения Blackswanfinance на ваших собственных
                    устройствах для некоммерческого использования в соответствии с условиями
                    настоящего Соглашения. условиях настоящего соглашения EULA. Лицензия на
                    Приложение предоставляется вам, и вы настоящим подтверждаете, что никакое
                    право собственности на Приложение не передается и не переуступается вам, и
                    настоящее соглашение EULA не должно истолковываться как продажа каких-либо
                    прав на Приложение.
                </Body>
                <Body left white>
                    Вам разрешено загружать приложение Blackswanfinance (например, на мобильный
                    телефон, планшет или ноутбук) под свой контроль. Вы несете ответственность
                    за то, чтобы ваше устройство соответствовало минимальным требованиям
                    приложения Blackswanfinance.
                </Body>
                <br />
                <Title3 white left>
                    4. ОГРАНИЧЕНИЯ
                </Title3>
                <br />
                <Body left white>
                    Без предварительного письменного согласия Blackswanfinance вы не можете
                    передавать свои права и обязанности по настоящему соглашению EULA, а также
                    перераспределять, обременять, продавать, сдавать в аренду, сублицензировать
                    или иным образом передавать свои права на Приложение.
                </Body>
                <Body white>
                    <ul style={{ textAlign: "left" }}>
                        <li>
                            редактировать, модифицировать, изменять, адаптировать или иным
                            образом изменять все или любую часть Приложения Blackswanfinance, а
                            также не разрешается объединение всего или любой части Приложения с
                            любым другим Приложением или любым программным обеспечением или их
                            включение в него, а также декомпиляцию, дизассемблирование или
                            провести реверс-инжиниринг Приложения или попытаться выполнить любое
                            из перечисленных действий,
                        </li>
                        <li>
                            копировать, воспроизводить, дублировать, перепродавать или
                            распространять на любом носителе любую часть Приложения, за
                            исключением случаев, когда это прямо разрешено Blackswanfinance,
                        </li>
                        <li>
                            удалять или изменять товарные знаки, логотипы или юридические
                            уведомления Blackswanfinance, включенные в Приложение или связанные
                            с ним активы,
                        </li>
                        <li>
                            удалять, отключать, обходить или иным образом создавать или внедрять
                            любые обходные пути для любых функций защиты от копирования,
                            управления правами или безопасности в Приложении или его защиты,
                        </li>
                        <li>
                            использовать сервис, чтобы попытаться получить несанкционированный
                            доступ к любому сервису, данным, учетной записи или сети любыми
                            способами,
                        </li>
                        <li>
                            использовать Приложение любым способом, который нарушает любое
                            применимое местное, национальное или международное право,
                        </li>
                        <li>
                            использовать Приложение для любых целей, которые Blackswanfinance
                            считает нарушением настоящего соглашения EULA.
                        </li>
                    </ul>
                </Body>
                <Body left white>
                    Blackswanfinance оставляет за собой право по своему усмотрению определять,
                    какое поведение считается нарушением условий настоящего соглашения EULA.
                    Используя наше Приложение, вы признаете и соглашаетесь, что использование
                    вами Приложения, включая любой отправляемый вами контент, будет
                    соответствовать настоящему соглашению EULA и всем применимым местным,
                    государственным, национальным и международным законам, правилам и
                    положениям.
                </Body>
                <br />
                <Title3 white left>
                    5. ИНТЕЛЛЕКТУАЛЬНАЯ СОБСТВЕННОСТЬ
                </Title3>
                <br />

                <Body left white>
                    Никакая часть настоящего соглашения EULA не может и не должна
                    интерпретироваться как передача прав интеллектуальной собственности.
                    Blackswanfinance сохраняет за собой право собственности на Приложение в том
                    виде, в каком оно было первоначально загружено вами, а также на все
                    последующие загрузки Приложения, сделанные вами. Приложение (а также
                    авторские права и другие права интеллектуальной собственности любого
                    характера в Приложении, включая любые внесенные в него изменения) являются и
                    остаются собственностью Blackswanfinance.
                </Body>
                <Body left white>
                    В дополнение к общим правилам, изложенным выше, положения данного раздела
                    применяются конкретно к использованию вами контента Blackswanfinance,
                    используемого в Приложении (контент Blackswanfinance). Содержимое
                    Blackswanfinance, используемое в этом Приложении, включая, помимо прочего,
                    текст, сценарии, исходный код, API, графику, фотографии, звуки, музыку,
                    видео и интерактивные функции, а также содержащиеся в нем товарные знаки,
                    знаки обслуживания и логотипы, принадлежат или лицензированы. к
                    Blackswanfinance на бессрочной основе и защищены авторским правом, товарным
                    знаком и/или патентной защитой.
                </Body>
                <Body left white>
                    Содержимое Blackswanfinance предоставляется вам «как есть», «как доступно» и
                    «со всеми ошибками» только для вашей информации и личного, некоммерческого
                    использования и не может быть загружено, скопировано, воспроизведено,
                    распространено, передано, транслировано, отображено, продано, лицензировано
                    или иным образом использовано для любых целей без предварительного
                    письменного согласия Blackswanfinance. Настоящее соглашение EULA не
                    предоставляет никаких прав или лицензий в соответствии с какими-либо
                    авторскими правами, товарными знаками, патентами или другими правами
                    собственности или лицензиями.
                </Body>
                <br />
                <Title3 white left>
                    6. СБОР И ИСПОЛЬЗОВАНИЕ ВАШЕЙ ИНФОРМАЦИИ
                </Title3>
                <br />
                <Body left white>
                    Вы признаете, что когда вы загружаете, устанавливаете или используете
                    Приложение, Blackswanfinance может использовать автоматические средства
                    (включая, например, файлы cookie и веб-маяки) для сбора информации о вашем
                    Мобильном устройстве и об использовании вами Приложения. От вас также может
                    потребоваться предоставить определенную информацию о себе в качестве условия
                    для загрузки, установки или использования Приложения или некоторых его
                    функций или возможностей. Вся информация, которую мы собираем с помощью
                    данного Приложения или в связи с ним, регулируется нашей Политикой
                    конфиденциальности. Загружая, устанавливая, используя и предоставляя
                    информацию в это Приложение или через него, вы соглашаетесь на все действия,
                    предпринимаемые нами в отношении вашей информации в соответствии с Политикой
                    конфиденциальности.
                </Body>
                <br />
                <Title3 white left>
                    7. ОБНОВЛЕНИЯ
                </Title3>
                <br />

                <Body left white>
                    Blackswanfinance может время от времени по своему усмотрению разрабатывать и
                    предоставлять обновления Приложения, которые могут включать обновления,
                    исправления ошибок, исправления, другие исправления ошибок и/или новые
                    функции (совместно, включая соответствующую документацию, «Обновления»).
                    Обновления также могут изменять или полностью удалять определенные функции и
                    возможности. Вы соглашаетесь с тем, что Blackswanfinance не обязана
                    предоставлять какие-либо Обновления или продолжать предоставлять или
                    включать какие-либо конкретные функции или возможности. В зависимости от
                    настроек вашего мобильного устройства, когда ваше мобильное устройство
                    подключено к Интернету:
                </Body>
                <Body white>
                    <ul style={{ textAlign: "left" }}>
                        <li>
                            Приложение автоматически загрузит и установит все доступные
                            Обновления; или
                        </li>
                        <li>
                            вы можете получить уведомление или предложение загрузить и
                            установить доступные обновления.
                        </li>
                    </ul>
                </Body>
                <Body left white>
                    Вы обязуетесь незамедлительно загрузить и установить все Обновления, а также
                    признать и согласиться с тем, что Приложение или его части могут работать
                    неправильно, если вы этого не сделаете. Вы также соглашаетесь с тем, что все
                    Обновления будут считаться частью Приложения и на них будут распространяться
                    все положения и условия настоящего Соглашения.
                </Body>
                <br />
                <Title3 white left>
                    8. ИСПОЛЬЗОВАНИЕ ПОЛЬЗОВАТЕЛЬСКОГО КОНТЕНТА BLACKSWANFINANCE
                </Title3>
                <br />
                <Body left white>
                    Приложение может позволять вам создавать такой контент, как видео, данные,
                    фотографии, сообщения, графику, текст и другую информацию («Пользовательский
                    контент»), а также делиться таким Пользовательским контентом с
                    Blackswanfinance или с другими приложениями, сайтами, включая социальные
                    сети. сайты. Положения данного раздела применяются конкретно к использованию
                    Blackswanfinance Пользовательского контента, размещенного в Приложении или
                    через него.
                </Body>
                <Body left white>
                    Вы несете единоличную ответственность за весь предоставленный вами
                    Пользовательский контент или Пользовательский контент, а также за
                    последствия и требования к его распространению. Вы соглашаетесь с тем, что
                    любой Пользовательский контент, которым вы делитесь, не нарушает и не будет
                    нарушать права третьих лиц любого рода, включая, помимо прочего, любые права
                    интеллектуальной собственности или права на публичность и
                    конфиденциальность, а также не будет содержать оскорбительный контент.
                </Body>
                <Body left white>
                    Что касается Пользовательского контента, отправляя или публикуя
                    Пользовательский контент в Приложении или через него, вы разрешаете Компании
                    использовать интеллектуальную собственность и другие права собственности на
                    ваш Пользовательский контент, чтобы обеспечить включение и использование
                    Пользовательского контента в порядке, предусмотренном данное Приложение и
                    настоящее соглашение EULA.
                </Body>
                <Body left white>
                    Создавая Пользовательский контент с помощью приложения Blackswanfinance, вы
                    тем самым предоставляете Blackswanfinance всемирную, неисключительную,
                    безвозмездную, сублицензируемую, безотзывную и передаваемую лицензию на
                    использование, воспроизведение, распространение, подготовку производных
                    работ, объединение с другими работами, отображение и использовать ваш
                    Пользовательский контент в связи с этим Приложением, в том числе, помимо
                    прочего, для продвижения и распространения всего или части этого Приложения
                    в любых медиаформатах и через любые медиаканалы без каких-либо ограничений и
                    без оплаты или иного вознаграждения любого рода, или разрешение или
                    уведомление вам или любой третьей стороне. Вы также настоящим предоставляете
                    каждому Пользователю этого Приложения неисключительную лицензию на доступ к
                    вашему Пользовательскому контенту через это Приложение, а также на
                    использование, воспроизведение, распространение, подготовку производных
                    работ, объединение с другими работами, отображение и исполнение вашего
                    Пользовательского контента в разрешенных случаях. посредством
                    функциональности данного Программного обеспечения и в соответствии с
                    настоящим соглашением EULA.
                </Body>
                <Body left white>
                    Вышеуказанные лицензии, предоставленные вами в отношении вашего
                    Пользовательского контента, прекращают свое действие в течение коммерчески
                    разумного периода времени после того, как вы удалите или удалите свой
                    Пользовательский контент из данного Приложения. Однако вы понимаете и
                    соглашаетесь с тем, что Blackswanfinance может сохранять (но не
                    распространять, отображать или выполнять) серверные копии вашего
                    Пользовательского контента, которые были удалены. Вышеуказанные лицензии,
                    предоставленные вами в вашем Пользовательском контенте, являются бессрочными
                    и безотзывными.
                </Body>
                <Body left white>
                    Blackswanfinance, как правило, не проводит предварительную проверку
                    Пользовательского контента, но оставляет за собой право (но не берет на себя
                    никаких обязательств) сделать это и решить, является ли какой-либо элемент
                    Пользовательского контента подходящим и/или соответствующим настоящему
                    соглашению EULA. Blackswanfinance может удалить любой элемент
                    Пользовательского контента, а также самого Пользователя, если он нарушает
                    настоящее соглашение EULA, в любое время и без предварительного уведомления.
                </Body>
                <br />
                <Title3 white left>
                    9. ПОЛЬЗОВАТЕЛЬСКИЕ МАТЕРИАЛЫ
                </Title3>
                <br />
                <Body left white>
                    Что касается пользовательских материалов, вы признаете и соглашаетесь с тем,
                    что:
                </Body>
                <Body white>
                    <ul style={{ textAlign: "left" }}>
                        <li>
                            ваши пользовательские материалы являются полностью добровольными,
                        </li>
                        <li>
                            ваши Пользовательские материалы не устанавливают конфиденциальных
                            отношений и не обязывают Blackswanfinance относиться к вашим
                            Пользовательским материалам как к конфиденциальным или секретным.
                        </li>
                        <li>
                            Blackswanfinance не несет никаких обязательств, явных или
                            подразумеваемых, по разработке или использованию ваших
                            Пользовательских материалов, и вам или кому-либо еще не
                            выплачивается компенсация за любое преднамеренное или
                            непреднамеренное использование ваших Пользовательских материалов.
                        </li>
                    </ul>
                </Body>
                <Body left white>
                    Blackswanfinance владеет исключительными правами (включая всю
                    интеллектуальную собственность и другие права собственности) на любые
                    Пользовательские материалы, предоставленные Blackswanfinance, и имеет право
                    на неограниченное использование и распространение любых Пользовательских
                    материалов, размещенных в Программном обеспечении или через Программное
                    обеспечение, для любых целей, коммерческих или иных. , без подтверждения или
                    компенсации вам или кому-либо еще.
                </Body>
                <br />
                <Title3 white left>
                    10. ЗАГРУЗКА ПРИЛОЖЕНИЯ ИЗ APPLE APP STORE
                </Title3>
                <br />
                <Body left white>
                    Следующее применимо к Приложению, доступ к которому осуществляется через
                    Apple App Store или загруженному из Apple App Store («Приложение, полученное
                    из App Store»):
                </Body>
                <Body white>
                    <ul style={{ textAlign: "left" }}>
                        <li>
                            Вы признаете и соглашаетесь, что (i) настоящее соглашение EULA
                            заключено только между вами и Blackswanfinance, а не Apple; и (ii)
                            Blackswanfinance, а не Apple, несет единоличную ответственность за
                            Приложение, полученное из App Store, и его содержимое. Использование
                            вами приложения из App Store должно соответствовать Условиям
                            обслуживания Apple App Store.
                        </li>
                        <li>
                            Вы будете использовать Приложение, полученное из App Store, только
                            (i) на продукте Apple, работающем под управлением iOS (собственное
                            программное обеспечение операционной системы Apple); и (ii) в
                            соответствии с «Правилами использования», изложенными в Условиях
                            обслуживания Apple App Store.
                        </li>
                        <li>
                            Вы признаете, что Apple не несет никаких обязательств по
                            предоставлению каких-либо услуг по обслуживанию и поддержке в
                            отношении Приложения, полученного из App Store.
                        </li>
                        <li>
                            В случае несоответствия какого-либо приложения, полученного из App
                            Store, какой-либо применимой гарантии, вы можете уведомить об этом
                            Apple, и Apple возместит вам покупную цену за приложение, полученное
                            из App Store, и в максимальной степени, разрешенной применимым
                            законодательством, Apple не будет иметь никаких других гарантийных
                            обязательств в отношении Приложения, полученного из App Store. В
                            отношениях между Blackswanfinance и Apple любые другие претензии,
                            убытки, обязательства, ущерб, затраты или издержки, связанные с
                            несоблюдением какой-либо гарантии, будут являться исключительной
                            ответственностью Blackswanfinance.
                        </li>
                        <li>
                            Вы и Blackswanfinance признаете, что в отношениях между
                            Blackswanfinance и Apple, Apple не несет ответственности за
                            рассмотрение любых претензий, которые у вас есть или любых претензий
                            любой третьей стороны, касающихся Приложения, полученного из App
                            Store, которым вы владеете, и использования Приложения, полученного
                            из App Store, включая, но не ограничиваясь (i) претензиями по
                            ответственности за качество продукции; (ii) любые претензии о том,
                            что Приложение, полученное из App Store, не соответствует каким-либо
                            применимым законодательным или нормативным требованиям; и (iii)
                            претензии, возникающие в соответствии с законодательством о защите
                            прав потребителей или аналогичным законодательством.
                        </li>
                        <li>
                            Вы и Blackswanfinance признаете, что в случае заявления какой-либо
                            третьей стороны о том, что приложение, полученное из App Store, или
                            ваше владение и использование этого исходного приложения из App
                            Store, нарушает права интеллектуальной собственности этой третьей
                            стороны, в отношениях между Blackswanfinance и Apple,
                            Blackswanfinance, а не Apple, будет нести единоличную
                            ответственность за расследование, защиту, урегулирование и
                            удовлетворение любых таких претензий о нарушении прав
                            интеллектуальной собственности в степени, требуемой настоящим
                            соглашением EULA.
                        </li>
                        <li>
                            Вы и Blackswanfinance признаете и соглашаетесь, что Apple и ее
                            дочерние компании являются сторонними бенефициарами настоящего
                            соглашения EULA и что после принятия вами настоящего соглашения EULA
                            Apple будет иметь право (и будет считаться, что приняла это право)
                            обеспечить соблюдение этого соглашения. Соглашение EULA.
                        </li>
                        <li>
                            Используя приложение, полученное из App Store, вы заявляете и
                            гарантируете, что (i) вы не находитесь в стране, на которую
                            распространяется эмбарго правительства США или которая была
                            определена правительством США как страна, «поддерживающая
                            терроризм»; и (ii) вы не числитесь ни в одном списке запрещенных или
                            ограниченных лиц правительства США.
                        </li>
                        <li>
                            Не ограничивая никакие другие условия настоящего соглашения EULA, вы
                            должны соблюдать все применимые условия соглашения третьих сторон
                            при использовании приложения, полученного из App Store.
                        </li>
                    </ul>
                </Body>
                <br />
                <Title3 white left>
                    11. ОТКАЗ ОТ ГАРАНТИЙ
                </Title3>
                <br />
                <Body left white>
                    ЕСЛИ ИНОЕ ЯВНО НЕ СОГЛАСОВАНО С КОМПАНИЕЙ BLACKSWANFINANCE В ПИСЬМЕННОЙ
                    ФОРМЕ, ПРИЛОЖЕНИЕ ПРЕДОСТАВЛЯЕТСЯ «КАК ЕСТЬ», «КАК ДОСТУПНО» И «СО ВСЕМИ
                    ДЕФЕКТАМИ» И ДЕФЕКТАМИ, И BLACKSWANFINANCE НЕ ДАЕТ НИКАКИХ ДРУГИХ ГАРАНТИЙ,
                    ЯВНЫХ ИЛИ ПОДРАЗУМЕВАЕМЫХ, ФАКТИЧЕСКИХ ИЛИ ЗАКОНОДАТЕЛЬНЫХ, ВКЛЮЧАЯ , НО НЕ
                    ОГРАНИЧИВАЯСЬ ​​ЛЮБЫМИ ПОДРАЗУМЕВАЕМЫМИ ГАРАНТИЯМИ ТОВАРНОЙ ЦЕННОСТИ,
                    ПРИГОДНОСТИ ДЛЯ ОПРЕДЕЛЕННОЙ ЦЕЛИ И НЕНАРУШЕНИЯ ПРАВ, КРОМЕ КАК УСТАНОВЛЕНО
                    В НАСТОЯЩЕМ СОГЛАШЕНИИ EULA.
                </Body>
                <Body left white>
                    BLACKSWANFINANCE НЕ ДАЕТ НИКАКИХ ГАРАНТИЙ ОТНОСИТЕЛЬНО (I) ТОЧНОСТИ, ПОЛНОТЫ
                    ИЛИ СОДЕРЖАНИЯ ЭТОГО ПРИЛОЖЕНИЯ И НЕ НЕСЕТ НИКАКОЙ ОТВЕТСТВЕННОСТИ.
                    BLACKSWANFINANCE НЕ ДАЕТ НИКАКИХ ГАРАНТИЙ, ЧТО РАБОТА ПРИЛОЖЕНИЯ БУДЕТ
                    БЕЗОПАСНОЙ, БЕЗОШИБОЧНОЙ ИЛИ БЕЗПЕРЕБОЙНОЙ.
                </Body>
                <Body left white>
                    НИКАКИЕ УСТНЫЕ ИЛИ ПИСЬМЕННЫЕ СОВЕТЫ, ПРЕДОСТАВЛЕННЫЕ BLACKSWANFINANCE ИЛИ
                    ЛЮБЫМ УПОЛНОМОЧЕННЫМ ПРЕДСТАВИТЕЛЕМ ИЛИ ТРЕТЬЕЙ ЛИЦОЙ, НЕ ДОЛЖНЫ СОЗДАВАТЬ
                    ГАРАНТИИ. В НЕКОТОРЫХ ЮРИСДИКЦИЯХ, НЕ ДОПУСКАЕТСЯ ИСКЛЮЧЕНИЕ ИЛИ ОГРАНИЧЕНИЕ
                    ПОДРАЗУМЕВАЕМЫХ ГАРАНТИЙ ИЛИ ОГРАНИЧЕНИЙ ПРИМЕНИМЫХ ЗАКОНОДАТЕЛЬНЫХ ПРАВ
                    ПОТРЕБИТЕЛЯ, ПОЭТОМУ НЕКОТОРЫЕ ИЛИ ВСЕ ВЫШЕУКАЗАННЫЕ ИСКЛЮЧЕНИЯ И
                    ОГРАНИЧЕНИЯ МОГУТ НЕ ПРИМЕНЯТЬСЯ К ВАМ.
                </Body>
                <Body left white>
                    ВЫШЕИЗВЕДЕННЫЙ ОТКАЗ ОТ ЗАЯВЛЕНИЙ И ГАРАНТИЙ ПРИМЕНЯЕТСЯ В МАКСИМАЛЬНОЙ
                    СТЕПЕНИ, РАЗРЕШЕННОЙ ЗАКОНОДАТЕЛЬСТВОМ, И ДЕЙСТВИТЕЛЬНО В ПРАВЕ ЛЮБОГО
                    ПРЕКРАЩЕНИЯ ИЛИ ИСТЕЧЕНИЯ ДЕЙСТВИЯ НАСТОЯЩЕГО СОГЛАШЕНИЯ EULA ИЛИ
                    ИСПОЛЬЗОВАНИЯ ВАМИ ЭТОГО САЙТА ИЛИ УСЛУГ, НАХОДЯЩИХСЯ НА ЭТОМ САЙТЕ.
                </Body>
                <br />
                <Title3 white left>
                    12. ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ
                </Title3>
                <br />
                <Body left white>
                    В МАКСИМАЛЬНОЙ СТЕПЕНИ, РАЗРЕШЕННОЙ ДЕЙСТВУЮЩИМ ЗАКОНОДАТЕЛЬСТВОМ, НИ ПРИ
                    КАКИХ ОБСТОЯТЕЛЬСТВАХ BLACKSWANFINANCE, ЕЕ ДОЛЖНОСТНЫЕ ЛИЦА, ДИРЕКТОРА,
                    СОТРУДНИКИ, АГЕНТЫ И ВСЕ СТОРОННИЕ ПОСТАВЩИКИ УСЛУГ НЕ НЕСУТ ОТВЕТСТВЕННОСТИ
                    ПЕРЕД ВАМИ ИЛИ ЛЮБЫМ ДРУГИМ ЛИЦОМ ИЛИ ОРГАНИЗАЦИЯМИ ЗА ЛЮБЫЕ ПРЯМЫЕ,
                    КОСВЕННЫЕ, СЛУЧАЙНЫЕ, СПЕЦИАЛЬНЫЕ, ШТРАФНЫЕ ИЛИ КОСВЕННЫЕ УБЫТКИ, ВКЛЮЧАЯ
                    ЛЮБЫЕ УБЫТКИ, КОТОРЫЕ МОГУТ БЫТЬ РЕЗУЛЬТАТОМ ИЗ (I) НАСТОЯЩЕГО СОГЛАШЕНИЯ,
                    (II) ТОЧНОСТИ, ПОЛНОТЫ ИЛИ СОДЕРЖАНИЯ ЭТОГО ПРИЛОЖЕНИЯ, (III) ИЛИ ПОСТАВКИ,
                    РАБОТЫ, УСТАНОВКИ ИЛИ ИСПОЛЬЗОВАНИЯ ПРИЛОЖЕНИЯ, ИЗ-ЗА НАРУШЕНИЯ КОНТРАКТА,
                    НАРУШЕНИЯ ГАРАНТИИ ИЛИ НЕБРЕЖНОСТИ BLACKSWANFINANCE ИЛИ ЛЮБОЙ ДРУГОЙ
                    СТОРОНЫ, ДАЖЕ ЕСЛИ BLACKSWANFINANCE ПРЕДВАРИТЕЛЬНО ПРЕДУПРЕЖДАЛОСЬ О
                    ВОЗМОЖНОСТИ ТАКОГО УБЫТКА.
                </Body>
                <Body left white>
                    В НЕКОТОРЫХ ЮРИСДИКЦИЯХ НЕ ДОПУСКАЕТСЯ ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ ЗА
                    СМЕРТЬ, ЛИЧНОЕ ТРАВМИРОВАНИЕ, МОШЕННИЧЕСКИЕ ИСКАЖЕНИЯ ИЛИ ОПРЕДЕЛЕННЫЕ
                    НАМЕРЕННЫЕ ИЛИ НЕБРЕЖНЫЕ ДЕЙСТВИЯ, ИЛИ НАРУШЕНИЕ КОНКРЕТНЫХ ЗАКОНОДАТЕЛЬСТВ,
                    ИЛИ ОГРАНИЧЕНИЕ СЛУЧАЙНЫХ ИЛИ КОСВЕННЫХ УБЫТКОВ, ТАКЖЕ НЕКОТОРЫЕ ИЛИ ВСЕ ИЗ
                    ВЫШЕПЕРЕДАННЫХ ОГРАНИЧЕНИЙ ОТВЕТСТВЕННОСТИ МОЖЕТ К ВАМ НЕ ОТНОСИТЬСЯ. НИ ПРИ
                    КАКИХ ОБСТОЯТЕЛЬСТВАХ ОБЩАЯ ОТВЕТСТВЕННОСТЬ BLACKSWANFINANCE ПЕРЕД ВАМИ ЗА
                    ВСЕ УБЫТКИ (ИСКЛЮЧАЯ ТРЕБУЕМЫЕ ДЕЙСТВУЮЩИМ ЗАКОНОДАТЕЛЬСТВОМ) НЕ ПРЕВЫШАЕТ
                    СУММУ, ФАКТИЧЕСКИ УПЛАЧЕННУЮ ВАМИ ЗА ЗАЯВЛЕНИЕ. ЭТО ОГРАНИЧЕНИЕ ПРИМЕНЯЕТСЯ,
                    НО НЕ ОГРАНИЧИВАЕТСЯ НИЧЕМ, СВЯЗАННЫМ С ПРИЛОЖЕНИЕМ, УСЛУГАМИ ИЛИ КОНТЕНТОМ,
                    ДОСТУПНЫМИ ЧЕРЕЗ ПРИЛОЖЕНИЕ. ВЫ СОГЛАШАЕТЕСЬ, ЧТО ПОЛОЖЕНИЯ НАСТОЯЩЕГО
                    СОГЛАШЕНИЯ С EULA, ОГРАНИЧИВАЮЩИЕ ОТВЕТСТВЕННОСТЬ, ЯВЛЯЮТСЯ СУЩЕСТВЕННЫМИ
                    УСЛОВИЯМИ НАСТОЯЩЕГО СОГЛАШЕНИЯ С EULA.
                </Body>
                <Body left white>
                    ВЫШЕ УКАЗАННОЕ ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ ПРИМЕНЯЕТСЯ В МАКСИМАЛЬНОЙ
                    СТЕПЕНИ, РАЗРЕШЕННОЙ ЗАКОНОДАТЕЛЬСТВОМ, И ДЕЙСТВИТЕЛЬНО ПРИ ЛЮБОМ
                    ПРЕКРАЩЕНИИ ИЛИ ИСТЕЧЕНИИ НАСТОЯЩЕГО СОГЛАШЕНИЯ.
                </Body>
                <br />
                <Title3 white left>
                    13. ВОЗМЕЩЕНИЕ
                </Title3>
                <br />
                <Body left white>
                    Вы соглашаетесь защищать, возмещать убытки и ограждать Blackswanfinance и ее
                    должностных лиц, директоров, сотрудников, агентов от любых претензий,
                    требований, издержек, потерь, обязательств и ущерба любого рода и характера
                    (включая, без ограничения, разумные гонорары адвокатов), наложенные или
                    понесенные Blackswanfinance, прямо или косвенно возникшие в результате (i)
                    использования вами Приложения; (ii) нарушением вами любого положения
                    настоящего Соглашения; и/или (iii) нарушением вами любого права третьих лиц,
                    включая, помимо прочего, любую интеллектуальную собственность или другие
                    права собственности. Обязательства по возмещению убытков в соответствии с
                    настоящим разделом остаются в силе после прекращения или истечения срока
                    действия настоящего Соглашения или использования вами Приложения.
                </Body>
                <br />
                <Title3 white left>
                    14. ДОСТУПНОСТЬ ПРИЛОЖЕНИЯ
                </Title3>
                <br />
                <Body left white>
                    В соответствии с условиями настоящего Соглашения и нашей политикой мы
                    приложим коммерчески разумные усилия, чтобы обеспечить круглосуточное
                    предоставление данного Приложения. Вы признаете и соглашаетесь с тем, что
                    время от времени это Приложение может быть недоступно по любой причине,
                    включая, помимо прочего, периодическое обслуживание, ремонт или замену,
                    которые мы проводим время от времени, или другие причины, находящиеся вне
                    нашего контроля, включая, помимо прочего, прерывание или выход из строя
                    линий электросвязи или цифровой передачи, а также другие сбои. Вы признаете
                    и соглашаетесь с тем, что мы не контролируем доступность этого Приложения на
                    постоянной или бесперебойной основе и что мы не несем никакой
                    ответственности перед вами или любой другой стороной в отношении этого.
                </Body>
                <br />
                <Title3 white left>
                    15. ПРЕКРАЩЕНИЕ
                </Title3>
                <br />
                <Body left white>
                    Настоящее Соглашение EULA вступает в силу с даты первой загрузки, установки
                    или использования Приложения и действует до момента прекращения его
                    действия. Вы можете расторгнуть настоящее Соглашение, удалив Приложение и
                    все его копии со своего Мобильного устройства. Настоящее соглашение EULA
                    также будет немедленно расторгнуто, если вы не выполните какое-либо условие
                    настоящего соглашения EULA. После такого прекращения действия лицензий,
                    предоставленных по настоящему соглашению EULA, немедленно прекращается
                    действие, и вы соглашаетесь прекратить любой доступ и использование
                    Приложения. Положения, которые по своей природе продолжают действовать и
                    остаются в силе, остаются в силе после прекращения действия настоящего
                    соглашения EULA.
                </Body>
                <Body left white>
                    Blackswanfinance оставляет за собой право прекратить предложение или
                    предоставление Приложения в любое время, по любой причине или без нее, и без
                    предварительного уведомления. Хотя Blackswanfinance прилагает большие усилия
                    для увеличения срока службы Приложения, возможно, что предлагаемое нами
                    Приложение будет прекращено. В этом случае настоящее соглашение EULA будет
                    расторгнуто, и Blackswanfinance больше не будет поддерживать Приложение.
                </Body>
                <Body left white>
                    После прекращения действия все права, предоставленные вам по настоящему
                    соглашению EULA, также аннулируются, и вы должны прекратить любое
                    использование Приложения и удалить все копии Приложения со своего Мобильного
                    устройства и учетной записи.
                </Body>
                <br />
                <Title3 white left>
                    16. СОБЛЮДЕНИЕ МЕСТНЫХ ЗАКОНОДАТЕЛЬСТВ
                </Title3>
                <br />
                <Body left white>
                    Blackswanfinance не делает никаких заявлений и не гарантирует, что весь
                    контент, доступный в этом Приложении, подходит для каждой страны или
                    юрисдикции, а использование этого Приложения в странах или юрисдикциях, где
                    его контент является незаконным, запрещено. Пользователи, решившие
                    использовать это Программное обеспечение, несут ответственность за
                    соблюдение всех местных законов, правил и положений.
                </Body>
                <br />
                <Title3 white left>
                    17. ПРИМЕНИМОЕ ЗАКОНОДАТЕЛЬСТВО
                </Title3>
                <br />
                <Body left white>
                    Настоящее Соглашение EULA и любые споры или претензии, возникающие из или в
                    связи с ним, его предметом или формированием, регулируются и толкуются в
                    соответствии с законодательством России, за исключением коллизионного права.
                </Body>
                <br />
                <Title3 white left>
                    18. НАЗВАНИЯ И ЗАГОЛОВКИ
                </Title3>
                <br />
                <Body left white>
                    Названия и заголовки настоящего соглашения EULA предназначены только для
                    удобства и простоты использования и не могут быть использованы каким-либо
                    образом для истолкования или толкования соглашения сторон, как иное изложено
                    в настоящем документе.
                </Body>
                <br />
                <Title3 white left>
                    19. ОГРАНИЧЕНИЕ ВРЕМЕНИ ДЛЯ ПОДАЧИ ПРЕТЕНЗИЙ
                </Title3>
                <br />
                <Body left white>
                    ЛЮБАЯ ПРИЧИНА ДЛЯ ИСКА ИЛИ ПРЕТЕНЗИИ, КОТОРАЯ У ВАС МОЖЕТ ВОЗНИКАТЬ ИЗ ИЛИ
                    СВЯЗАННОЙ С ЭТИМ СОГЛАШЕНИЕМ ИЛИ ЗАЯВЛЕНИЕМ, ДОЛЖНА БЫТЬ НАЧАЛАСЬ В ТЕЧЕНИЕ
                    ОДНОГО (1) ГОДА ПОСЛЕ ВОЗНИКНОВЕНИЯ ПРИЧИНЫ ИСКА ИЛИ ПРЕТЕНЗИИ, В противном
                    случае ТАКАЯ ПРИЧИНА ИЛИ ПРЕТЕНЗИЯ СТАНОВИТСЯ ЗАПРЕЩЕННОЙ.
                </Body>
                <br />
                <Title3 white left>
                    20. РАЗДЕЛИМОСТЬ
                </Title3>
                <br />
                <Body left white>
                    Каждое соглашение и соглашение в настоящем соглашении EULA должно
                    толковаться для всех целей как отдельное и независимое соглашение или
                    соглашение. Если суд компетентной юрисдикции признает какое-либо положение
                    (или часть положения) настоящего соглашения EULA незаконным,
                    недействительным или иным образом не имеющим исковой силы, остальные
                    положения (или части положений) настоящего соглашения EULA не будут
                    затронуты и будут быть признаны действительными и подлежащими исполнению в
                    максимальной степени, разрешенной законом.
                </Body>
                <br />
                <Title3 white left>
                    21. КОНТАКТНАЯ ИНФОРМАЦИЯ
                </Title3>
                <br />
                <Body left white>
                    Если у вас есть какие-либо вопросы по поводу настоящего соглашения EULA,
                    свяжитесь с нами по электронной или обычной почте по следующему адресу:
                </Body>
                <Body left white>
                    ООО "ДАТА ТЕКНОЛОДЖИС ЭНД АНАЛИТИКС КОНСАЛТИНГ"
                </Body>
                <Body left white>
                    150000, обл. Ярославская, г. Ярославль, ул. Первомайская, 7А, помещ. 1
                </Body>
                <Body left white>
                    info@blackswan.finance
                </Body>
                <br />
            </ModalContent>
            <ModalFooter />
        </Modal>
    );
};

export default LicenceModal;
